/* Grand Candles collection filtering — candidate theme only.
   Filters the complete rendered collection on the client (mood/season/type/availability/price),
   keeps state in the URL, updates faceted counts and drives the mobile filter dialog. */
(() => {
  const KEYS = ['type', 'mood', 'season', 'availability'];
  const PARAM = { type: 'f_type', mood: 'f_mood', season: 'f_season', availability: 'f_stock' };

  const init = root => {
    if (root.dataset.gcReady) return;
    root.dataset.gcReady = '1';
    const grid = root.querySelector('[data-gc-grid]');
    if (!grid) return;
    const drawer = root.querySelector('[data-gc-filter-drawer]');
    const state = { type: new Set(), mood: new Set(), season: new Set(), availability: new Set(), min: null, max: null };

    const cards = () => [...grid.querySelectorAll('[data-gc-card]')];
    const dataOf = c => c._gc || (c._gc = {
      type: c.dataset.type || '',
      moods: (c.dataset.moods || '').split(',').filter(Boolean),
      season: c.dataset.season || 'everyday',
      available: c.dataset.available === 'true',
      price: Number(c.dataset.price || 0),
    });
    const inGroup = (d, key, value) => {
      if (key === 'type') return d.type === value;
      if (key === 'mood') return d.moods.includes(value);
      if (key === 'season') return d.season === value;
      if (key === 'availability') return value === 'in-stock' ? d.available : !d.available;
      return false;
    };
    const passKey = (d, key) => !state[key].size || [...state[key]].some(v => inGroup(d, key, v));
    const passPrice = d => (state.min === null || d.price >= state.min) && (state.max === null || d.price <= state.max);
    const passes = (d, except) => KEYS.every(k => k === except || passKey(d, k)) && passPrice(d);
    const toCents = v => { const n = parseFloat(String(v).replace(',', '.')); return Number.isFinite(n) && n >= 0 ? Math.round(n * 100) : null; };
    const money = c => (c / 100).toFixed(2).replace(/\.00$/, '');

    const labels = {};
    root.querySelectorAll('input[data-gc-filter-value]').forEach(i => { labels[`${i.dataset.gcKey}:${i.value}`] = i.dataset.gcLabel || i.value; });

    const readUrl = () => {
      const p = new URLSearchParams(location.search);
      KEYS.forEach(k => { state[k] = new Set((p.get(PARAM[k]) || '').split(',').filter(Boolean)); });
      state.min = p.has('f_min') ? toCents(p.get('f_min')) : null;
      state.max = p.has('f_max') ? toCents(p.get('f_max')) : null;
    };
    const writeUrl = () => {
      const url = new URL(location.href);
      KEYS.forEach(k => (state[k].size ? url.searchParams.set(PARAM[k], [...state[k]].join(',')) : url.searchParams.delete(PARAM[k])));
      state.min !== null ? url.searchParams.set('f_min', money(state.min)) : url.searchParams.delete('f_min');
      state.max !== null ? url.searchParams.set('f_max', money(state.max)) : url.searchParams.delete('f_max');
      history.replaceState(history.state, '', url);
    };
    const syncInputs = source => {
      root.querySelectorAll('input[data-gc-filter-value]').forEach(i => { i.checked = state[i.dataset.gcKey].has(i.value); });
      root.querySelectorAll('[data-gc-price-min]').forEach(i => { if (i !== source) i.value = state.min === null ? '' : money(state.min); });
      root.querySelectorAll('[data-gc-price-max]').forEach(i => { if (i !== source) i.value = state.max === null ? '' : money(state.max); });
    };

    const apply = () => {
      const all = cards();
      let shown = 0;
      all.forEach(c => { const ok = passes(dataOf(c)); c.hidden = !ok; if (ok) shown += 1; });
      root.querySelectorAll('input[data-gc-filter-value]').forEach(i => {
        const key = i.dataset.gcKey;
        const n = all.reduce((a, c) => { const d = dataOf(c); return a + (passes(d, key) && inGroup(d, key, i.value) ? 1 : 0); }, 0);
        i.dataset.gcCount = String(n);
        const label = i.closest('label');
        const out = label?.querySelector('[data-gc-count-label]');
        if (out) out.textContent = `(${n})`;
        i.disabled = n === 0 && !i.checked;
        label?.classList.toggle('is-disabled', i.disabled);
      });
      const total = all.length;
      const catalogTotal = Number(grid.dataset.total) || total;
      root.querySelectorAll('[data-gc-result-count]').forEach(el => {
        if (catalogTotal > total) {
          el.textContent = shown === total ? `Showing ${total} of ${catalogTotal} products` : `Showing ${shown} of ${catalogTotal} products`;
        } else {
          el.textContent = shown === total ? `${total} ${total === 1 ? 'product' : 'products'}` : `Showing ${shown} of ${total} products`;
        }
      });
      root.querySelectorAll('[data-gc-apply-count]').forEach(el => { el.textContent = String(shown); });
      root.querySelectorAll('[data-gc-empty]').forEach(el => { el.hidden = shown !== 0; });
      const active = root.querySelector('[data-gc-active]');
      if (active) {
        const chips = [];
        KEYS.forEach(k => state[k].forEach(v => chips.push({ k, v, text: labels[`${k}:${v}`] || v })));
        if (state.min !== null) chips.push({ k: 'min', text: `From $${money(state.min)}` });
        if (state.max !== null) chips.push({ k: 'max', text: `Up to $${money(state.max)}` });
        active.replaceChildren(...chips.map(ch => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'gc-chip gc-chip--remove';
          b.dataset.k = ch.k;
          if (ch.v) b.dataset.v = ch.v;
          b.setAttribute('aria-label', `Remove filter: ${ch.text}`);
          b.textContent = ch.text;
          return b;
        }));
        const wrap = active.closest('[data-gc-active-wrap]');
        if (wrap) wrap.hidden = chips.length === 0;
      }
    };

    const fromPrice = t => {
      const v = t.value.trim() === '' ? null : toCents(t.value);
      if (t.matches('[data-gc-price-min]')) state.min = v; else state.max = v;
      syncInputs(t); apply(); writeUrl();
    };
    let priceTimer;

    root.addEventListener('change', e => {
      const t = e.target;
      if (t.matches('input[data-gc-filter-value]')) {
        const set = state[t.dataset.gcKey];
        t.checked ? set.add(t.value) : set.delete(t.value);
        syncInputs(t); apply(); writeUrl();
      } else if (t.matches('[data-gc-price-min], [data-gc-price-max]')) {
        clearTimeout(priceTimer); fromPrice(t);
      } else if (t.matches('[data-gc-sort]')) {
        const url = new URL(location.href);
        url.searchParams.set('sort_by', t.value);
        url.searchParams.delete('page');
        location.assign(url);
      }
    });
    root.addEventListener('input', e => {
      const t = e.target;
      if (!t.matches('[data-gc-price-min], [data-gc-price-max]')) return;
      clearTimeout(priceTimer);
      priceTimer = setTimeout(() => fromPrice(t), 300);
    });
    root.addEventListener('click', e => {
      const remove = e.target.closest('.gc-chip--remove');
      if (remove) {
        const { k, v } = remove.dataset;
        if (k === 'min') state.min = null; else if (k === 'max') state.max = null; else state[k].delete(v);
        syncInputs(); apply(); writeUrl();
        return;
      }
      if (e.target.closest('[data-gc-filter-clear]')) {
        KEYS.forEach(k => state[k].clear());
        state.min = null; state.max = null;
        syncInputs(); apply(); writeUrl();
        return;
      }
      const loadMore = e.target.closest('[data-gc-load-more]');
      if (loadMore) {
        loadNextBatch();
        return;
      }
      if (drawer && e.target.closest('[data-gc-filter-open]')) { drawer.showModal(); return; }
      if (drawer && e.target.closest('[data-gc-filter-apply], [data-gc-filter-close]')) drawer.close();
    });
    drawer?.addEventListener('click', e => { if (e.target === drawer) drawer.close(); });
    drawer?.addEventListener('close', () => root.querySelector('[data-gc-filter-open]')?.focus({ preventScroll: true }));

    let isLoadingMore = false;
    const loadNextBatch = async () => {
      if (isLoadingMore) return;
      const loadMoreBtn = root.querySelector('[data-gc-load-more]');
      const loadMoreWrap = root.querySelector('[data-gc-load-more-wrap]');
      let next = loadMoreBtn?.dataset.nextUrl || grid.dataset.nextUrl;
      if (!next) {
        if (loadMoreWrap) loadMoreWrap.hidden = true;
        return;
      }
      isLoadingMore = true;
      if (loadMoreBtn) {
        loadMoreBtn.disabled = true;
        loadMoreBtn.setAttribute('aria-busy', 'true');
        const span = loadMoreBtn.querySelector('span');
        if (span) span.textContent = 'Loading...';
      }

      try {
        const url = new URL(next, location.origin);
        url.searchParams.set('section_id', root.dataset.sectionId);
        const res = await fetch(url, { credentials: 'same-origin' });
        if (res.ok) {
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const g = doc.querySelector('[data-gc-grid]');
          if (g) {
            const existingHrefs = new Set(cards().map(c => c.querySelector('a')?.getAttribute('href')).filter(Boolean));
            const incomingCards = [...g.querySelectorAll('[data-gc-card]')];
            incomingCards.forEach(c => {
              const href = c.querySelector('a')?.getAttribute('href');
              if (!href || !existingHrefs.has(href)) {
                if (href) existingHrefs.add(href);
                grid.append(document.adoptNode(c));
              }
            });
            const newNext = g.dataset.nextUrl || doc.querySelector('[data-gc-load-more]')?.dataset.nextUrl || '';
            grid.dataset.nextUrl = newNext;
            if (loadMoreBtn) loadMoreBtn.dataset.nextUrl = newNext;
            if (!newNext && loadMoreWrap) {
              loadMoreWrap.hidden = true;
            }
            apply();
          }
        }
      } catch (err) {
        console.error('Error loading more products:', err);
      } finally {
        isLoadingMore = false;
        if (loadMoreBtn) {
          loadMoreBtn.disabled = false;
          loadMoreBtn.removeAttribute('aria-busy');
          const span = loadMoreBtn.querySelector('span');
          if (span) span.textContent = 'Load more products';
        }
      }
    };

    readUrl();
    syncInputs();
    apply();
    if (root.querySelector('[data-gc-load-more]')) {
      root.querySelectorAll('[data-gc-pagination]').forEach(p => { p.hidden = true; });
    }
  };

  const boot = () => document.querySelectorAll('[data-gc-collection]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
